import React, { useState } from "react";
import RecordButton from "../Components/RecordButtonClass";
import ButtonContainer from "../Components/ButtonContainer";
import PageNumber from "../Components/PageNumber";
import COLORS from "../Colors.js";
import { withRouter } from "react-router-dom";
import "../Styles/Test.css";
import Popup from "../Components/Popup";
import SymbolMatchingGame from "../Components/SymbolMatchingGame";
import { PATH_NAMES, RECORDING_NAMES, SYMBOL_TASK } from "../Utilities/Constants";
import * as api from "../Scripts/Api";

function Test(props) {
  var startSymbolTime1 = new Date().getTime();

  var sessionStartTime = sessionStorage.getItem("startSymbol1");
  if ( sessionStartTime === 0 || sessionStartTime === null) {
    sessionStorage.setItem("startSymbol1", startSymbolTime1);
  }

  console.log(
    "start TIME FOR SYMBOL 1 !!, ",
    sessionStorage.getItem("startSymbol1")
  );

  let starting_question = 0;
  let index = Number(sessionStorage.getItem("testIdx"));
  if (index && index <= 12 && index > 0) {
    starting_question = index;
  }

  const [questionIdx, setQuestionIdx] = useState(starting_question);
  const [symbolStart, setSymbolStart] = useState(false);
  const [popupIdx, setPopupIdx] = useState(0);

  let buttonOnClick = () => {
    if (questionIdx === questions.length - 1) {
      props.history.push({
        pathname: PATH_NAMES.FINISH,
      });
    } else {
      sessionStorage.setItem("testIdx", questionIdx + 1);
      setQuestionIdx(questionIdx + 1);
    }

    if (
      questions[questionIdx + 1] &&
      !questions[questionIdx + 1].recordIndex &&
      window.stream
    ) {
      window.stream.getTracks().forEach((track) => track.stop());
    }
  };

  let updateIndex = (index) => {
    setPopupIdx(index);
  };
  /* Beginning of English Questions */
  let questions_english = [
    {
      instructions: [
        <SymbolMatchingGame demo={true} onCompletion={buttonOnClick} />,
      ],
      popup_text: [
        <div>
          <p>
            For the next task you will be asked to match specific symbols with
            specific numbers.{" "}
          </p>
        </div>,
      ],
      confirmation_text: ["Tap here to begin the task"],
    },
    {
      instructions: [
        <p></p>,
        <SymbolMatchingGame
          demo={false}
          name={SYMBOL_TASK + "_1"}
          onCompletion={() => {
            //console.log("CURRENT question INDEX, sym match 1: ", questionIdx);
            console.log(
              "correct number in test.js: ",
              sessionStorage.getItem("thisRoundCorrect")
            );
            let thisCorr1 = sessionStorage.getItem("thisRoundCorrect");
            sessionStorage.setItem("SymMatch_Corr_1", thisCorr1);
            //sessionStorage.setItem("thisRoundCorrect", 0);
            console.log(
              "birthday of this person: ",
              sessionStorage.getItem("birthtext")
            );
            let endSymbolTime1 = new Date().getTime();
            console.log("END of symbol 1!!! ", endSymbolTime1);
            let timeSpentSym1 =
              endSymbolTime1 - sessionStorage.getItem("startSymbol1");
            sessionStorage.setItem("timeSymMatch1", timeSpentSym1);
            let sym1Seconds = timeSpentSym1/1000.0;

            api.record_prompt_response("SYM_MATCH_1", thisCorr1);
            
            console.log("TIME Sym 1 took in seconds: ", sym1Seconds);

            buttonOnClick();
            setSymbolStart(false);
            sessionStorage.setItem("thisRoundCorrect", 0);
          }}
          started={symbolStart}
        />,
      ],
      popup_text: [
        <div>
          <p>
            You will have 90 seconds to complete this task. You will not be able
            to go back and correct previous answers, and a new sequence of
            numbers will appear as you complete each sequence.
          </p>
          <p>Please tap the button below when you are ready to begin.</p>
        </div>,
      ],
      confirmation_text: ["Tap here to go to the task"],
      popupCallback: () => {setSymbolStart(true); sessionStorage.setItem("thisRoundCorrect", 0);},
    },
    {
      instructions: [
        <p>
          <b>
            Thinking back, can you tell a story about something important that
            happened to you in your life?
          </b>
        </p>,
        <p>
          It could be happy or sad or from any time -- from when you were a kid
          or more recently. Something important…
        </p>,
        <p>
          For instance, you could talk about a trip you took or something about
          your family or your work -- anything.
        </p>,
      ],
      popup_text: [
        <div>
          <p>Time has run out.</p>
        </div>,
        <div>
          <p>The next task will involve recording your voice.</p>
        </div>,
      ],
      confirmation_text: ["OK", "Tap here to go to the voice task"],
      recordIndex: 1,
      name: RECORDING_NAMES.VOICE_MEMORY,
    },
    {
      instructions: [<p>Now, count backward from 305 to 285.</p>],
      popup_text:[<div><p>Your recording has been saved.</p></div>],
      confirmation_text: ['Tap here to continue to the next voice task'],
      recordIndex: -1,
      name: RECORDING_NAMES.VOICE_COUNT
    },
    {
      instructions: [
        <SymbolMatchingGame
          demo={false}
          name={SYMBOL_TASK + "_2"}
          onCompletion={() => {
            //console.log("q index sym match 2: ", questionIdx);
            buttonOnClick();
            let endSymbolTime2 = new Date().getTime();
            console.log("END of symbol 2!!! ", endSymbolTime2);
            let timeSpentSym2 =
              endSymbolTime2 - sessionStorage.getItem("startSymbol2");
            sessionStorage.setItem("timeSymMatch2", timeSpentSym2);
            //api.record_prompt_response("SYM_MATCH_2", timeSpentSym2);
            console.log("TIME Sym 2 took: ", timeSpentSym2);
            let sym2Seconds = timeSpentSym2/1000.0;
            console.log("TIME Sym 2 took IN SECONDS: ", sym2Seconds);

            let thisCorr2 = sessionStorage.getItem("thisRoundCorrect");

            api.record_prompt_response("SYM_MATCH_2", thisCorr2);

            sessionStorage.setItem("SymMatch_Corr_2", thisCorr2);
            sessionStorage.setItem("finishTest", true);
            console.log("FINISHED TEST IS TRUE!!!");
          }}
          started={symbolStart}
        />,
      ],
      popup_text: [
        <div>
          <p>You will now repeat the symbol matching task.</p>
        </div>,
      ],
      confirmation_text: ["Tap here to begin the second symbol matching task"],
      popupCallback: () => setSymbolStart(true),
    },
    {
      instructions: [<p>Time has run out.</p>],
    },
  ];
  /* End of English Questions */

  /* Beginning of Spanish Questions */
  let questions_espanol = [
    {
      instructions: [
        <SymbolMatchingGame demo={true} onCompletion={buttonOnClick} />,
      ],
      popup_text: [
        <div>
          <p>
          Para la siguiente tarea, se le pedirá que relacione símbolos específicos con números específicos{" "}
          </p>
        </div>,
      ],
      confirmation_text: ["Toque aquí para comenzar la tarea"],
    },
    {
      instructions: [
        <p></p>,
        <SymbolMatchingGame
          demo={false}
          name={SYMBOL_TASK + "_1"}
          onCompletion={() => {
            //console.log("CURRENT question INDEX, sym match 1: ", questionIdx);
            console.log(
              "correct number in test.js: ",
              sessionStorage.getItem("thisRoundCorrect")
            );
            let thisCorr1 = sessionStorage.getItem("thisRoundCorrect");
            sessionStorage.setItem("SymMatch_Corr_1", thisCorr1);
            //sessionStorage.setItem("thisRoundCorrect", 0);
            console.log(
              "birthday of this person: ",
              sessionStorage.getItem("birthtext")
            );
            let endSymbolTime1 = new Date().getTime();
            console.log("END of symbol 1!!! ", endSymbolTime1);
            let timeSpentSym1 =
              endSymbolTime1 - sessionStorage.getItem("startSymbol1");
            sessionStorage.setItem("timeSymMatch1", timeSpentSym1);
            let sym1Seconds = timeSpentSym1/1000.0;

            api.record_prompt_response("SYM_MATCH_1", thisCorr1);
            
            console.log("TIME Sym 1 took in seconds: ", sym1Seconds);

            buttonOnClick();
            setSymbolStart(false);
            sessionStorage.setItem("thisRoundCorrect", 0);
          }}
          started={symbolStart}
        />,
      ],
      popup_text: [
        <div>
          <p>
          Tendrás 90 segundos para completar esta tarea. No podrá volver atrás y corregir las respuestas anteriores, y aparecerá una nueva secuencia de números a medida que complete cada secuencia.
          </p>
          <p>Toque el botón a continuación cuando esté listo para comenzar.</p>
        </div>,
      ],
      confirmation_text: ["Toca aquí para ir a la tarea"],
      popupCallback: () => {setSymbolStart(true); sessionStorage.setItem("thisRoundCorrect", 0);},
    },
    {
      instructions: [
        <p>
          <b>
          ¿Pensando en retrospectiva, puede contar una historia sobre algo importante que sucedió en su vida? 
          </b>
        </p>,
        <p>
          Podría ser feliz o triste o de cualquier momento - desde cuando eras niño/a o más recientemente.
          Algo importante…
        </p>,
        <p>
          Por ejemplo, hable de un viaje que hizo o algo sobre su familia o su trabajo - cualquier cosa.
        </p>,
      ],
      popup_text: [
        <div>
          <p>El tiempo se acabó.</p>
        </div>,
        <div>
          <p>La siguiente tarea consistirá en grabar tu voz.</p>
        </div>,
      ],
      confirmation_text: ["Bueno", "Toque aquí para ir a la tarea de voz"],
      recordIndex: 1,
      name: RECORDING_NAMES.VOICE_MEMORY,
    },
    {
      instructions: [<p>Ahora, cuente hacia atrás desde 305 hasta 285.</p>],
      popup_text:[<div><p>Tu grabación ha sido guardada.</p></div>],
      confirmation_text: ['Toque aquí para continuar con la siguiente tarea de voz.'],
      recordIndex: -1,
      name: RECORDING_NAMES.VOICE_COUNT
    },
    {
      instructions: [
        <SymbolMatchingGame
          demo={false}
          name={SYMBOL_TASK + "_2"}
          onCompletion={() => {
            //console.log("q index sym match 2: ", questionIdx);
            buttonOnClick();
            let endSymbolTime2 = new Date().getTime();
            console.log("END of symbol 2!!! ", endSymbolTime2);
            let timeSpentSym2 =
              endSymbolTime2 - sessionStorage.getItem("startSymbol2");
            sessionStorage.setItem("timeSymMatch2", timeSpentSym2);
            //api.record_prompt_response("SYM_MATCH_2", timeSpentSym2);
            console.log("TIME Sym 2 took: ", timeSpentSym2);
            let sym2Seconds = timeSpentSym2/1000.0;
            console.log("TIME Sym 2 took IN SECONDS: ", sym2Seconds);

            let thisCorr2 = sessionStorage.getItem("thisRoundCorrect");

            api.record_prompt_response("SYM_MATCH_2", thisCorr2);

            sessionStorage.setItem("SymMatch_Corr_2", thisCorr2);
            sessionStorage.setItem("finishTest", true);
            console.log("FINISHED TEST IS TRUE!!!");
          }}
          started={symbolStart}
        />,
      ],
      popup_text: [
        <div>
          <p>Ahora repetirá la tarea de hacer coincidir símbolos.</p>
        </div>,
      ],
      confirmation_text: ["Toque aquí para comenzar la segunda tarea de coincidencia de símbolos."],
      popupCallback: () => setSymbolStart(true),
    },
    {
      instructions: [<p>El tiempo se acabó.</p>],
    },
  ];
/* End of Spanish Questions */

  let prefLang = sessionStorage.getItem("preferredLanguage")
  let questions = prefLang !== "ES" ? questions_english : questions_espanol
  let continueText = prefLang !== "ES" ? "Tap here to continue" : "Toca aquí para continuar"

  console.log("QUESTION INDEX: " + questionIdx);
  console.log("RECORD INDEX: " + questions[questionIdx].recordIndex);
  let showRecordButton =
    questions[questionIdx].recordIndex &&
    popupIdx >= questions[questionIdx].recordIndex;
  let nonRecord =
    questionIdx === 0 ||
    questionIdx === 1 ||
    questionIdx === 4 ||
    questionIdx === 6;

    function validate(event){
      const enteredCode = prompt('Please enter the passcode to skip')
      if (enteredCode === "1290"){
        buttonOnClick()
      }else{
        alert("Please don't skip this part")
      }
    }

  return (
    <div>
      <PageNumber testPage={questionIdx + 1} />
      {questions[questionIdx].popup_text && (
        <Popup
          popup_text={questions[questionIdx].popup_text}
          confirmation_text={questions[questionIdx].confirmation_text}
          callback={questions[questionIdx].popupCallback}
          questionIdx={questionIdx}
          updateIndex={updateIndex}
        />
      )}
      <div className="test-container">
        {questions[questionIdx].instructions.map((instruction, index) => {
          return instruction;
        })}
        <br />
        {nonRecord ? (
          <br />
        ) : showRecordButton ? (
          <RecordButton
            onStop={buttonOnClick}
            name={questions[questionIdx].name}
            key={questions[questionIdx].name}
          />
        ) : (
          <ButtonContainer
            colors={[COLORS.blue]}
            buttonTexts={[continueText]}
            buttonType="filled"
            onClick={buttonOnClick}
          />
        )}
      </div>
      <button class="btn-2" style={{backgroundColor:"white", color:"white", float:"right", alignSelf: 'flex-end', fontSize:30}} onClick={(event) => validate(event)}>
        skip
        </button>
    </div>
  );
}

export default withRouter(Test);
